var lastWidth = 0;
var animarGaleria = {};
var animarBanner = {};